module.exports = __webpack_public_path__ + "static/2b-9b05a28dc01998c57da373a4a4871d6b.jpg";